import { FaqState } from "../types/state";
import { RootState } from "../../applicationStore";
import { createSelector } from "@reduxjs/toolkit";
import { LOADING } from "../../../types";
import { TalesFaq } from "../../../utils/types/TalesFaq";

export const getFaqState = (state: RootState): FaqState => state.faq;

export const getFaqData = createSelector(
  getFaqState,
  (faqState): TalesFaq[] | null => faqState?.data,
);

export const getFaqError = createSelector(
  getFaqState,
  (sponsorState): string | null => sponsorState?.error,
);

export const isFaqLoading = createSelector(
  getFaqState,
  (sponsorState): boolean => sponsorState?.loading === LOADING.PENDING ?? false,
);
